import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Button, Col, Row, Container} from "reactstrap";
import {Textarea} from "../form/fields/Textarea";
import DropZone, {DropZoneStore} from "../../stores/DropZoneStore";
import {api} from "../../api";
import {Checkbox} from "../form/fields/Checkbox";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export class PartyFormData {
    @observable name = '';
    @observable email = '';
    @observable party_code = '';
    @observable contact_person = '';
    @observable phone_number = '';
    @observable address = '';
    @observable other_details = '';
    @observable is_active = true;
    @observable disable_reigstration = true;
    @observable upload_id = null;
    @observable party_logo = {};
    @observable is_add_user = false;
    @observable user_info = {
        name: '',
        email: '',
        phone_number: '',
        password: '',
        confirm_password: ''
    };
}

export class PartyForm extends CrudForm {
    modelName = 'Party';
    dropZoneStore = new DropZoneStore();
    @observable user_count: number = 0;

    djsConfig = {
        maxFilesize: 1,
        acceptedFiles: "image/jpeg,image/png,image/gif",
        maxSize: 1024,
        paramName: "file_upload",
        params: {
            file_field: 'party_logo',
        }
    };

    componentConfig = {
        postUrl: 'upload',
    };

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await api.party.getDetailAction(this.id).then((data: any) => {
                let party: any =  data.data;
                party.user_info = {
                    name: '',
                    email: '',
                    phone_number: '',
                    password: '',
                    confirm_password: ''
                };
                this.formStore.setData(party);
                this.entity = party;
                this.user_count = data.data.user_count;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    eventHandlers = {

        error: (file: any, response: any) => {
            //const message = response.message ? 'error in upload' : response;
            //this.props.rootStore.messageStore.showErrorMessage(message);
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
        },
        success: (file: any, response: any) => {
            this.dropZoneStore.progress = 0;
            this.dropZoneStore.uploadButtonEnabled = true;
            this.formStore.setValue('upload_id', response.upload_id);
            this.formStore.setValue('party_logo', response);
            // update user profile to link image to user
            //this.postData(this.formStore.data);
        },
    };

    onClickButton(event: any) {
        event.preventDefault();
    };


    userFormFields() {
        return (
            <>
                {
                    this.user_count == 0 ?
                        <Field
                            name="is_add_user"
                            label={"Want to add user ?"}
                            component={Checkbox}
                            required={true}
                            store={this.formStore}
                            title="Want to Add user"
                            helpText="Note: Do you want to create default user for party?"
                            inline={true}
                        /> : ''
                }
                {
                    this.user_count == 0 && this.formStore.getValue('is_add_user') ?
                        <>
                            <hr/>

                             <h4 className="text-center">Party Admin</h4>

                            <Field
                                label="Name"
                                name="user_info.name"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />

                            <Field
                                label="Email"
                                name="user_info.email"
                                type="email"
                                component={Input}
                                store={this.formStore}
                            />

                            <Field
                                label="Phone number"
                                name="user_info.phone_number"
                                component={Input}
                                required={true}
                                store={this.formStore}
                            />

                            <Field
                                label="Password"
                                name="user_info.password"
                                type="password"
                                component={Input}
                                store={this.formStore}
                            />

                            <Field
                                label="Confirm Password"
                                name="user_info.confirm_password"
                                type="password"
                                component={Input}
                                store={this.formStore}
                            />
                        </> : ''}
            </>
        )
    }

    renderFields() {
        return (
            <>
            

                <DropZone
                    store={this.dropZoneStore}
                    componentConfig={this.componentConfig}
                    djsConfig={this.djsConfig}
                    eventHandlers={this.eventHandlers}
                >
                    <Button className="image-uploader" onClick={this.onClickButton}>
                        {
                            this.formStore.getValue('party_logo') && this.formStore.data.party_logo.urls ?
                                <img src={this.formStore.data.party_logo.urls.thumb}
                                     style={{width: 120, height: 120}}/> :
                                <img src="https://fakeimg.pl/120/120"/>
                        }
                    </Button>
                    <div
                        className="form-progress-bar"
                        style={{width: `${this.dropZoneStore.progress}%`}}
                    />
                </DropZone>
                <br/>
                <Field
                    label="Party Code"
                    name="party_code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Party Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Contact Person"
                    name="contact_person"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Email"
                    name="email"
                    type="email"
                    component={Input}
                    store={this.formStore}
                />

                <Field
                    label="Phone number"
                    name="phone_number"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Address"
                    name="address"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Other Details"
                    name="other_details"
                    component={Textarea}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
				<h6>Remote Registration Allowed? :</h6>
				<Field
                    name="disable_reigstration"
                    component={BooleanRadios}
                    trueLabel="No"
                    falseLabel="Yes"
                    store={this.formStore}
                />

                {this.userFormFields()}
            </>
        );
    }
}

export class PartyFilterForm {
    @observable load_collection = true;
}

export class PartyList extends CrudList {
    modelName = 'Party';

    colums() {
        return [
            {
                name: "logo",
                label: "Logo",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {
                                item.party_logo && item.party_logo.url ?
                                    <img src={item.party_logo.url} style={{width: 70, height: 70}}/> :
                                    <img src="https://fakeimg.pl/70x70/"/>
                            }
                        </>
                    );
                },
            },
            {
                name: "party_code",
                label: "Party Code",
				sort: true,
            },
            {
                name: "name",
                label: "Party name",
				sort: true,
            },
            {
                name: "contact_person",
                label: "Contact Person",
				sort: true,
            },
            {
                name: "email",
                label: "Email",
				sort: true,
            },
            {
                name: "phone_number",
                label: "Phone",
				sort: true,
            },
            {
                name: "login",
                label: "Login",
                formatter: (value: any, item: any) => {
                    return item.user_count > 0 && (
                        <>
                            <Button color="positions" onClick={() => this.loginUser(item)}><span
                                className="icon-users"/></Button>
                        </>
                    ) ;
                },
				
            },
			{
                name: "unique_code",
                label: "Copy",
                formatter: (value: any, item: any) => {
                    return item.unique_code != null && (
                        <>
                            <Button color="positions" onClick={() => window.navigator['clipboard'].writeText(window.location.host+"/user-polling-unit/" + item.unique_code)}><span
                                className="icon-print"/></Button>
                        </>
                    ) ;
                },
				
            },
        ];
    }

    idColumn() {
        return '';
    }

    async loginUser(party: any) {
        await api.party.getDetailAction(party.id).then((data: any) => {
            window.location.href = 'user/login/' + data.data.token;
        });
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class PartyPage extends CrudPage {
    modelName = 'Party';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PartyPage.tsx